// extracted by mini-css-extract-plugin
module.exports = {"videoPlaceholder":"mp4-video-player-cover_videoPlaceholder__qCJRO"};